import { TeamBalanceCard } from '../views/leads-management/components/team-balance-card';
import { BarChartOutlined } from '@ant-design/icons';
import styles from './team-balance.module.scss';

export const TeamBalance = ({ teamBalance, fetchTeamBalance, loading }) => {
  return (
    <TeamBalanceCard
      title="Current Team Balance"
      Icon={BarChartOutlined}
      onRefresh={fetchTeamBalance}
      loading={loading}>
      {!teamBalance || teamBalance.length === 0 ? (
        <div className={styles.empty_state}>No team balance data available.</div>
      ) : (
        teamBalance.map((member, index) => (
          <div key={index} className={styles.member_row}>
            <div className={styles.member_name}>
              {member.first_name} {member.last_name}
            </div>
            <div className={styles.bar_container}>
              <div className={styles.bar_filled} style={{ width: `${((member.total ?? 0) / 20) * 100}%` }} />
            </div>
            <div className={styles.leads_count}>{member.total ?? 0} leads</div>
          </div>
        ))
      )}
    </TeamBalanceCard>
  );
};
